export default "__VITE_ASSET__CMnOPv3___"